import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-complaint-reg-sanction-form',
  templateUrl: './complaint-reg-sanction-form.component.html',
  styleUrls: ['./complaint-reg-sanction-form.component.css']
})
export class ComplaintRegSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/depart-enquiry/complaint-reg-sanction/complaint-reg-sanction-form/complaint-reg-sanction-form.component.ts